<template>
  <div class="section-main__warp task-detail">
    <div class="left">
      <div style="margin: 10px">
        <a class="back-btn" @click="backClick"><i class="iconfont icon-iconfontfanhui"></i>
          {{$t('carPatrol.button.back')}}
        </a>
      </div>
      <div class="info">
        <div class="names">
          <span>{{$t('carPatrol.label.name')}}</span>
          <span>{{formData.name}}</span>
        </div>
        <div class="info-taskname">
          <span>{{$t('carPatrol.label.time')}}</span>
          <span>{{formData.startDate |moment("YYYY.MM.DD")}}-{{formData.endDate|moment("YYYY.MM.DD")}}</span>
        </div>
        <div class="info-taskname info-taskname-time">
          <span>{{$t('carPatrol.label.cameraGroups')}}</span>
          <span class="time-content">
            <template>
              <div v-for="(item, index) in bayonetList" :key="index" :title="item.name">{{item.name}}</div>
            </template>
          </span>
          <div class="clear"></div>
        </div>
        <div class="info-taskname info-taskname-time">
          <span>{{$t('carPatrol.label.timeQuantum')}}</span>
          <span class="time-content">
            <template>
              <div v-for="(item, index) in formData.timeList" :key="index">{{item.day | weekFilter}}&nbsp;{{item.startTime}}-{{item.endTime}}</div>
            </template>
          </span>
          <div class="clear"></div>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="cut-line"></div>
      <span class="info-title">{{$t('carPatrol.label.carList')}}</span>
      <div class="list">
        <div class="item-content" @click="showCarDetail(item)" v-for="(item, index) in carList" :key="index">
          <div class="img-content">
            <img :src="getImgPath(item.vehicleList && item.vehicleList[0])"
                 class="image" onerror="this.src='/images/theme/newDark/default.png'">
          </div>
          <div class="item-right">
            <el-form label-position="right" label-width="80px">
              <el-form-item :label="$t('carPatrol.label.carer')">
                <el-tooltip class="item" effect="dark" :content="item.ownerName" placement="top-start">
                  <p>{{item.ownerName}}</p>
                </el-tooltip>
              </el-form-item>
              <el-form-item :label="$t('carPatrol.label.carNo')">
                <el-tooltip class="item" effect="dark" :content="item.plateCode" placement="top-start">
                  <p>{{item.plateCode}}</p>
                </el-tooltip>
              </el-form-item>

              <el-form-item :label="$t('carPatrol.label.carType')">
                <el-tooltip class="item" effect="dark" :content="item.plateCode" placement="top-start">
                  <p>{{item.vehicleType | carTypeFilter}}</p>
                </el-tooltip>
              </el-form-item>

              <el-form-item :label="$t('carPatrol.label.carColor')">
                <el-tooltip class="item" effect="dark" :content="item.plateCode" placement="top-start">
                  <p>{{item.vehicleColor | carColorFilter}}</p>
                </el-tooltip>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <map-gis class="gis-box" ref="igis"></map-gis>
    </div>
    <ioc-drawer
      :width="350"
      class="car-detail"
      :title="$t('carPatrol.title.lookDetails')"
      show-close
      v-model="dialogFormVisible"
      :custom-class="drawerControl"
      :modal="false"
    >
      <div class="content_img">
        <img :src="getImgPath(detailData.vehicleList && detailData.vehicleList[0])" class="image" onerror="this.src='/images/theme/newDark/default.png'">
      </div>
      <div>
        <el-form label-position="right" label-width="80px">
          <el-form-item :label="$t('carPatrol.label.carer')">
            <el-tooltip class="item" effect="dark" :content="detailData.ownerName" placement="top-start">
              <p>{{detailData.ownerName}}</p>
            </el-tooltip>
          </el-form-item>
          <el-form-item :label="$t('carPatrol.label.carNo')">
            <el-tooltip class="item" effect="dark" :content="detailData.plateCode" placement="top-start">
              <p>{{detailData.plateCode}}</p>
            </el-tooltip>
          </el-form-item>

          <el-form-item :label="$t('carPatrol.label.carType')">
            <el-tooltip class="item" effect="dark" :content="detailData.plateCode" placement="top-start">
              <p>{{detailData.vehicleType | carTypeFilter}}</p>
            </el-tooltip>
          </el-form-item>

          <el-form-item :label="$t('carPatrol.label.carColor')">
            <el-tooltip class="item" effect="dark" :content="detailData.plateCode" placement="top-start">
              <p>{{detailData.vehicleColor | carColorFilter}}</p>
            </el-tooltip>
          </el-form-item>
        </el-form>
      </div>
    </ioc-drawer>
  </div>
</template>
<script>
import i18n from '@src/common/lib/i18n'
import { Dic, Log, Bus } from '$utils'
import {api} from '../api'
export default {
  filters: {
    weekFilter (el) {
      let week
      switch (el) {
        case '1':
          week = i18n.t('carPatrol.label.oneDay')
          break;
        case '2':
          week = i18n.t('carPatrol.label.twoDay')
          break;
        case '3':
          week = i18n.t('carPatrol.label.threeDay')
          break;
        case '4':
          week = i18n.t('carPatrol.label.fourDay')
          break;
        case '5':
          week = i18n.t('carPatrol.label.fiveDay')
          break;
        case '6':
          week = i18n.t('carPatrol.label.satDay')
          break;
        case '0':
          week = i18n.t('carPatrol.label.sunDay')
          break;
        default: 
          week = ''
      }
      return week
    },
    carTypeFilter (el) {
      if (el === null) {
        return ''
      } else {
        return Dic.findByValue('SENU038', el)
      }
    },
    carColorFilter (el) {
      if (el === null) {
        return ''
      } else {
        return Dic.findByValue('SENU039', el)
      }
    }
  },
  components: {
  },
  data() {
    return {
      igisMap: null,
      iconObj: null,
      detailData: {},
      dialogFormVisible: false,
      drawerControl: 'drawer-control',
      formData: {},
      carList: [],
      params:{
        pageNum:1,
        pageSize:100,
        repositorCodes:[]
      },
      image:'',
      imageList:'',
      bayonetList: []
    }
  },
  mounted() {
    this.getTaskDetails(this.$route.query.code)
  },
  methods: {
    /*
     *@name: 返回车辆布控页面
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-22 16:16:21
    */
    backClick () {
      this.$router.push({
        path: '/carPatrol/index'
      })
    },
    //图片回显
    getImgPath(item){
      return item ? Bus.imgPath(item.fileCode) :""
    },
    // 查询布控详情
    getTaskDetails(code) {
      this.$fetch(api.task.queryVehicleTaskDetails,
           {code}
      ).then(response => {
        if (response.success) {
          this.formData = response.returnObj[0]
          this.formData.timeList.map((item, index) =>{
            item.startTime = item.startTime.slice(0,5)
            item.endTime = item.endTime.slice(0,5)
          })
          console.log('测试数据',this.formData.timeList)
          let repositorCodeslist = this.formData.groupList
          repositorCodeslist.forEach(item => {
            this.params.repositorCodes.push(item.repositoriesCode)
          })
          this.getList()
          this.getCamera()
        }}
        )
    },
    //获取车辆布控车辆详情
    getList(){
      this.$fetch(api.task.queryBwPlatByRepositorCodes,this.params).then(response => {
        if (response.success) {
          this.carList = response.returnObj.list;
          this.detailData = response.returnObj.list;
        // 图片列表
           for(let v =0;v<this.detailData.length;v++){
             this.imageList = this.detailData[v].vehicleList
           }
        }})
    },
    /*
     *@name: 获取布控摄像机组下摄像机
     *@param:{type} 
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-11 16:40:35
    */
    getCamera () {
      const _self = this
      this.$fetch(api.task.queryCameralist, {
        bayonetList: this.formData.bayonetList
      }).then(res => {
        console.log(res.returnObj)
        this.bayonetList = this.formData.bayonetList.map(item => {
          return {
            name: '',
            code: item
          }
        })
        res.returnObj.forEach(ritem => {
          this.bayonetList.forEach((bitem, index) => {
            if (ritem.code === bitem.code) {
              this.bayonetList[index].name = ritem.bayonetName
            }
          })
        })
        console.log(this.bayonetList)
        this.igisMap = this.$refs.igis.map
        this.iconObj && this.igisMap.removeLayer(this.iconObj)
        this.iconObj = new window.iGis.layers.IconLayer({
          gisMapObj: _self.igisMap,
          isRef: true,
          isHover: true,
          layerOptions: {
            isBox: false,
            anchor: [10, -10]
          }
        })
        let drawPoint = []
        res.returnObj.forEach(item => {
          drawPoint.push({
            src: 'images/map/resource/camera_red.png',
            label: item.deviceName,
            coord: [item.lng,item.lat]
          })
        })
        this.iconObj.setData(drawPoint, 0);
      })
    },
    showCarDetail(data) {
      this.dialogFormVisible = true
      this.detailData = data;
    }
  }
}
</script>

<style scoped lang='scss'>
.task-detail {
  position: relative;
  .left {
    width: 300px;
    float: left;
    height: 800px;
    overflow: hidden;
    .back-btn {
      cursor: pointer;
      margin-bottom: 10px;
    }
    .info {
      padding: 10px;
      height: 25%;
      overflow-y: auto;
      position: relative;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      .info-taskname {
        height: 40px;
        line-height: 25px;
        display: block;
        &.info-taskname-time {
          height: auto;
          display: flex;
          flex-direction: row;
          .time-content {
            flex: 1;
            max-height: 200px;
            overflow-y: auto;
            div {
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
      }
      span {
        margin: 0 5px;
      }
    }
    .cut-line {
      margin-bottom: 10px;
      height: 1px;
      border-bottom: 1px solid rgba(151, 150, 150, 0.4);
    }
    .info-title {
      padding: 10px;
    }
    .list {
      margin-top: 15px;
      padding: 10px;
      height: 70%;
      overflow-y: auto;
      .item-content {
        margin-bottom: 20px;
        padding: 5px;
        background-color: #152942;
        display: flex;
        height: 130px;
        .img-content {
          width: 130px;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item-right {
          width: 140px;
          .el-form-item--mini.el-form-item {
            margin-bottom: 0;
            .el-form-item__content {
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  .right {
    overflow: hidden;
    height: 800px;
    .gis-box {
      height: 100%;
    }
  }
  .car-detail {
    position: absolute;
    right: 0;
    top: 0;
    width: 300px;
    height: 100%;
    img {
      width: 100%;
    }
  }
  span.info-item-left,
  span.info-item-right {
    display: inline-block;
    box-sizing: border-box;
    padding: 5px 10px;
  }
  .item .item-right span.info-item-left {
    padding: 0;
    padding-right: 5px;
  }
  .item .item-right span.info-item-right {
    padding: 0;
    padding-left: 5px;
  }
  .info-item-left {
    text-align: right;
    width: 40%;
  }
  .info-item-right {
    text-align: left;
    width: 60%;
  }
}

.clear {
  clear: both;
}
.content_img {
  /*width: 205px;*/
  /*height: 295px;*/
  margin: 20px 18%
}
.names{
  height: 40px;
  line-height: 20px;
  display: block;
  word-wrap: break-word;
  word-break: break-all;
  overflow:hidden;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #fff !important;

}

::-webkit-scrollbar-thumb{
  border-radius: 10px;
  border-color: #fff !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #fff !important;
}
/* IE滚动条Start */
body{

}
</style>